import { Confirm } from "../../../confirm/confirm";
import { reject } from "q";
import Axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from "axios";
import { Notification } from "../../../notification/notfication";

export namespace Redis {
  export const BASE_SELECTOR = '#redis-page';
  
  /**
   * used for the request to flush the redis db
   */
  export interface FlushDBResponse {
    state : boolean;
    message : string | null;
  }
  
  export interface ResetDBPassword {
    state : boolean;
    message : string | null;
    password : string | null;
  }
  
  export class InfoPage {
    constructor() {
      this._bindActions();
    }
    
    private _bindActions() {
      $('.button--redis--action').on('click', (event : JQuery.TriggeredEvent) => { this._redisClickHandler(event) });
    }
  
    /**
     *
     * @returns {AxiosRequestConfig}
     * @private
     */
    private _getAjaxHeader() : AxiosRequestConfig {
      return {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
    }
    /**
     *
     * @returns {AxiosPromise<boolean>}
     * @private
     */
    private _flushRedisDatabase(requestUrl : string) : Promise<boolean> {
      let url : string = requestUrl;
      
      return new Promise<boolean>((resolve, reject) => {
        Axios.post(url, {}, this._getAjaxHeader()).then((response : AxiosResponse<FlushDBResponse>) => {
          resolve(response.data.state);
        }).catch((error : any) => {
          reject(error);
        })
      });
    }
    
    private _resetDatabasePassword(requestUrl : string) : Promise<ResetDBPassword> {
      let url : string = requestUrl;
  
      return new Promise<ResetDBPassword>((resolve, reject) => {
        Axios.post(url, {}, this._getAjaxHeader()).then((response : AxiosResponse<ResetDBPassword>) => {
          resolve(response.data);
        }).catch((error : any) => {
          reject(error);
        })
      });
    }
  
    /**
     *
     * @param {JQuery.TriggeredEvent} event
     * @param {boolean} state
     * @private
     */
    private _disable(event : JQuery.TriggeredEvent, state : boolean) {
      state === true
        ? $(event.target).attr('disabled', 'disabled')
        : $(event.target).removeAttr('disabled');
    }
  
    /**
     *
     * @param {JQuery.TriggeredEvent} event
     * @returns {boolean}
     * @private
     */
    private _isDisabled(event : JQuery.TriggeredEvent) : boolean {
      if(!$(event.target).is('[disabled]')) {
        return false;
      }
      
      if($(event.target).attr('disabled') === 'disabled') {
        return true;
      }
      
      return false;
    }
    
    /**
     *
     * @param {JQuery.TriggeredEvent} event
     * @private
     */
    private _redisClickHandler(event : JQuery.TriggeredEvent) : void {
      let action : string | undefined = $(event.target).attr('data-action');
      let url : string | undefined = $(event.target).attr('data-href');
      
      if(!this._isDisabled(event)) {
        this._disable(event, true);
        
        if(typeof action !== typeof undefined && typeof url !== typeof undefined) {
          switch(action) {
            case 'flushDB':
              new Confirm('Do you really want to delete this',
                () => {
                  this._flushRedisDatabase(url).then((response : boolean) => {
                    new Notification(
                      'success',
                      'Redis Database',
                      'The Redis Database has been flushed successfully'
                    );
                  }).catch(error => {
                    console.log(error);
                    
                    new Notification(
                      'danger',
                      'Redis Database',
                      'The Redis Database could not be flushed successfully'
                    );
                  }).then(value => {
                    this._disable(event, false);
                  });
                },
                () => {
                  this._disable(event, false);
                });
              break;
              
            case 'resetRedisPassword':
              this._resetDatabasePassword(url).then((response : ResetDBPassword) => {
                if(response.state === true && response.password !== null) {
                  new Notification(
                    'success',
                    'Redis Password',
                    'A new redis password has been successfully set'
                  );
                  
                  $('[data-placeholder=\'redis-password\']').text(response.password);
                  
                }
              }).catch(error => {
                new Notification(
                  'danger',
                  'Redis Password',
                  'The Redis Password could not be changed'
                );
              }).then(value => {
                this._disable(event, false);
              });
              break;
          }
        }
      }
    }
  }
  
  export function initRedis() {
    if($(Redis.BASE_SELECTOR).length) {
      console.log('init redis');
      new Redis.InfoPage();
    }
  }
}
